/**
 * Touch: Erst Inhalt in .slide-content scrollen, am Rand Slide-Wechsel (Fullpage).
 * @see https://github.com/nolimits4web/swiper/issues/1467
 */

import { SWIPER_NO_SWIPE_SELECTOR } from "./swiper-interactive-links.js";

const SCROLL_EDGE_TOLERANCE = 2;

const getOverflowScrollParent = (root, target) => {
  let el = target;
  while (el && el !== root) {
    if (el.scrollHeight > el.clientHeight + SCROLL_EDGE_TOLERANCE) {
      const { overflowY } = window.getComputedStyle(el);
      if (
        overflowY === "auto" ||
        overflowY === "scroll" ||
        overflowY === "overlay"
      ) {
        return el;
      }
    }
    el = el.parentElement;
  }

  if (root.scrollHeight > root.clientHeight + SCROLL_EDGE_TOLERANCE) {
    return root;
  }

  return null;
};

const shouldScrollInside = (
  scrollEl,
  startScrollTop,
  touchStartY,
  touchCurrentY,
) => {
  const touchesDiff = touchCurrentY - touchStartY;
  const maxScroll = scrollEl.scrollHeight - scrollEl.clientHeight;
  const atTop = startScrollTop <= SCROLL_EDGE_TOLERANCE;
  const atBottom = startScrollTop >= maxScroll - SCROLL_EDGE_TOLERANCE;
  const inMiddle =
    startScrollTop > SCROLL_EDGE_TOLERANCE &&
    startScrollTop < maxScroll - SCROLL_EDGE_TOLERANCE;

  if (inMiddle) return true;
  if (touchesDiff < 0 && atTop) return true;
  if (touchesDiff > 0 && atBottom) return true;

  return false;
};

/**
 * @param {HTMLElement} container .fullscreen-swiper
 * @param {() => HTMLElement | null} getActiveSlideContent
 */
export function initSwiperNestedScroll(container, getActiveSlideContent) {
  let startScrollTop = 0;
  let touchStartY = 0;
  let activeScrollEl = null;

  container.addEventListener(
    "touchstart",
    (e) => {
      if (!e.touches?.length) return;

      if (e.target.closest?.(SWIPER_NO_SWIPE_SELECTOR)) return;

      const slideContent = e.target.closest?.(".slide-content");
      const activeContent = getActiveSlideContent();
      if (!slideContent || slideContent !== activeContent) return;

      activeScrollEl = getOverflowScrollParent(slideContent, e.target);
      if (!activeScrollEl) return;

      startScrollTop = activeScrollEl.scrollTop;
      touchStartY = e.touches[0].pageY;
    },
    { capture: true, passive: true },
  );

  container.addEventListener(
    "touchmove",
    (e) => {
      if (!activeScrollEl || !e.touches?.length) return;

      const touchCurrentY = e.touches[0].pageY;
      if (
        shouldScrollInside(
          activeScrollEl,
          startScrollTop,
          touchStartY,
          touchCurrentY,
        )
      ) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    },
    { capture: true, passive: true },
  );

  const reset = () => {
    activeScrollEl = null;
  };

  container.addEventListener("touchend", reset, {
    capture: true,
    passive: true,
  });
  container.addEventListener("touchcancel", reset, {
    capture: true,
    passive: true,
  });
}
